// Media coverage of Sweat for Sacrifice. Add a new object to the TOP of the
// array for each new story (Newsday next) — /news and the "In the news"
// block on /legacy both read from here, so nothing else needs touching.
//
// Images are stored in our own object storage and served through
// /api/uploads/press/<file> so we never depend on an outlet's CDN.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const PRESS = [
  {
    id: "news12-2026-09-05",
    outlet: "News 12",
    outletNote: "Long Island",
    kicker: "Video segment",
    headline: "Suffolk woman turns fitness into tribute for 9/11 victims",
    dek: "A Middle Island fitness coach honors her two uncles who died from 9/11-related illnesses by launching a fitness challenge to keep their memories alive and support first responders.",
    excerpt:
      "Alanna Johnson, a fitness coach from Middle Island, created the \u201cSweat for Sacrifice\u201d challenge in memory of her uncles, Harry D\u2019Onofrio, an NYPD officer from West Sayville, and Timothy Goss, an FDNY Marine firefighter from Wading River. Both responded to Ground Zero on Sept. 11, 2001.",
    pullQuote:
      "I thought of the idea to make a challenge with movement. 911 minutes for 9/11. We\u2019re able-bodied people. Taking time out of your day to dedicate to someone who you\u2019re moving for is just honorable.",
    author: "Jeremy Skiba",
    authorTitle: "News 12 Long Island",
    dateLabel: "September 5, 2026",
    date: "2026-09-05",
    url: "https://longisland.news12.com/2026/09/05/suffolk-woman-turns-fitness-into-tribute-for-911-victims/B8ptuzGDPNnWtCYgCSAo7",
    // News 12 has no iframe embed. This is their OWN official video source
    // (the exact HLS stream their article player uses, served from the
    // News 12 / Altice CDN with CORS open) — no third-party mirror.
    video: {
      hls: "https://vod.prod.alticeustech.com/transcode/3ca5347b-d618-4377-a989-9f40bee6a85c/3ca5347b-d618-4377-a989-9f40bee6a85c.m3u8",
      poster: `${BACKEND}/api/uploads/press/news12-sweat-for-sacrifice-poster.jpg`,
    },
    imageCredit: "News 12 Long Island",
    featuredVideo: true,
  },
  {
    id: "patch-2026-09-03",
    outlet: "Patch",
    outletNote: "Sayville–Bayport, NY",
    kicker: "Patch Exclusive",
    headline: "Nationwide 911-Minute Challenge Honors 2 Long Island First Responders",
    dek: "Alanna Johnson created Sweat for Sacrifice after losing both uncles to illnesses connected to their Sept. 11 service.",
    excerpt:
      "A nationwide movement challenge with roots in West Sayville is asking people to spend September completing 911 minutes of physical activity in honor of two first responders whose lives were forever changed by the Sept. 11 attacks.",
    pullQuote:
      "I think what really hit me is that both of them essentially made one of the most frightening decisions imaginable that morning. They had the choice to keep going home and instead chose to go back in.",
    author: "Kepherd Daniel",
    authorTitle: "Patch Staff",
    dateLabel: "September 3, 2026",
    date: "2026-09-03",
    url: "https://patch.com/new-york/sayville/nationwide-911-minute-challenge-honors-2-long-island-first-responders",
    image: `${BACKEND}/api/uploads/press/patch-sweat-for-sacrifice-lead.jpg`,
    imageAlt:
      "Harry D'Onofrio, left, and Timothy \u201cTimmy\u201d Goss, the two first responders honored by the Sweat for Sacrifice Legacy Challenge, pictured with the Twin Towers.",
    imageCredit: "Courtesy Alanna Johnson",
    shareCardId: "patch-2026-09-03",
    shareCaption:
      "Sweat for Sacrifice was featured in Patch.\n\n" +
      "The Sweat for Sacrifice Legacy Challenge asks participants to complete 911 minutes of movement during September in honor of Timothy \u201cTimmy\u201d Goss, an FDNY Marine 1 firefighter, and Harry D\u2019Onofrio, an NYPD Emergency Service Unit detective and former West Sayville fire chief. Both returned to Ground Zero on September 11, 2001, and later died from illnesses connected to their service.\n\n" +
      "Anyone, anywhere can join \u2014 about 30 minutes of movement a day. All funds raised are divided equally between the Tunnel to Towers Foundation and the FDNY Fire Family Transport Foundation.\n\n" +
      "Read the story: https://patch.com/new-york/sayville/nationwide-911-minute-challenge-honors-2-long-island-first-responders\n" +
      "Join the challenge: https://sweatwithslay.com/legacy\n\n" +
      "#SweatForSacrifice #LegacyChallenge #911MinutesOfMovement #NeverForget #TunnelToTowers #FDNY #NYPD #SweatWithSlay",
    featured: true,
  },
];

export const FEATURED_PRESS = PRESS.find((p) => p.featured) || PRESS[0] || null;
export const FEATURED_VIDEO = PRESS.find((p) => p.featuredVideo && p.video) || null;

export default PRESS;
